import React, { useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import IconHeader from "../../images/logo-lg.png";
import QuoteSlider from "./QuoteSlider";
import "./index.scss";
import axios from "axios";
import apiConfig from "./apiConfig";

const quotes = [
  "Easily discover and quickly benefit from the most advanced technologies.",
  "Expert-level insights at your fingertips.",
  "Expedite planning, fieldwork and completion procedures.",
  "Elevate your expertise and confidence.",
  "AI-powered audits: Save time, increase profitability, and improve quality.",
];

function ForgotPassword() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Validation schema using Yup
  const validationSchema = Yup.object({
    email: Yup.string()
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Invalid email address"
      )
      .required("Email is required"),
  });

  // Formik for handling form submission
  const formik = useFormik({
    validateOnChange: true,
    validateOnBlur: false,
    initialValues: {
      email: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      try {
        setLoading(true);

        const response = await axios.post(
          `${apiConfig.apiBaseURL}/forgotPassword`,
          { email: values.email },
          {
            headers: {
              "x-api-key": apiConfig["x-api-key"],
              "Content-Type": "application/json"
            }
          }
        );

        if (response.data.success) {
          console.log("Password reset OTP sent to your email", response.data);

          toast.success(response.data.message, {
            position: toast.POSITION.TOP_RIGHT,
          });

          const userId = response.data.id;
          const email = values.email;

          // Redirecting to OTP verification
          setTimeout(() => navigate("/otp-verification", { state: { userId, email, signUp: false } }), 2000);
        }
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || error.message || "Forgot password request failed. Please try again.";
        toast.error(errorMessage);
      } finally {
        setLoading(false);
      }
    },
  });

  // Convert email to lowercase
  const handleEmailChange = (event) => {
    formik.setFieldValue("email", event.target.value.toLowerCase());
  };

  return (
    <section className="credential-page">
      <Container fluid>
        <Row className="justify-content-md-center" style={{ minHeight: "100vh" }}>
          <Col lg={6} className="p-0">
            <div className="left-side d-md-flex align-items-center justify-content-center bg-light">
              <QuoteSlider quotes={quotes} />
            </div>
          </Col>

          <Col lg={6} className="right-side">
            <div className="mb-4 card-title">
              <figure className="text-center mb-5">
                <LazyLoadImage src={IconHeader} alt="logo" className="img-fluid" />
              </figure>
              <h5 className="fw-bolder text-dark">Forgot Password</h5>
              <p>There is nothing to worry about, we'll send you a message to help you reset your password.</p>
            </div>

            <Form onSubmit={formik.handleSubmit} noValidate>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label className="mb-1">Email Address<sup>*</sup></Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter email"
                  onChange={handleEmailChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                  name="email"
                  className="p-3"
                  isInvalid={formik.touched.email && formik.errors.email}
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.email}
                </Form.Control.Feedback>
              </Form.Group>

              <Button
                variant="primary"
                className="mt-4 border-0 text-white font-16 px-5 py-3 w-100"
                type="submit"
                disabled={formik.isSubmitting || loading}
              >
                {loading ? "Sending..." : "Send OTP"}
              </Button>
            </Form>

            <Link to="/login" className="text-secondary text-decoration-none text-center d-block mt-4">
              Remember your password? <span className="text-primary fw-bolder">Sign in</span>
            </Link>
          </Col>
        </Row>

        {/* <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} /> */}
      </Container>
    </section>
  );
}

export default ForgotPassword;
